enum BusinessErrorEnum {
  InvalidInput,
  Unauthorized,
  NotFound,
  PasswordUpdateFailed,
  RefreshTokenFailed,
  ETC,
  UserInfoLoadFailed,
  AccountDeletionAlreadyScheduled,
  UserHasNoDevices,
}

export default BusinessErrorEnum;
